var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Runner } from "../../framework/Runner";
import { buildFlyoverTracks } from "./buildFlyoverTracks";
/**
 * General purpose 'flyover' runner that will load a scene and move the camera over the scene following the given
 * sequence of waypoints.
 *
 * Takes a list of waypoints to move between, focus points to look at, and the durations each leg will take.
 *
 * 'durations[0]' will be ignored, as the camera will instantly snap to 'positions[0]' and 'focuses[0]'. 'durations[1]'
 * will encode the time to move between 'positions[0]' and 'positions[1]'.
 *
 * 'durations', 'positions' and 'focuses' should all be the same size. If they are not then the number of steps will be
 * clamped to the size of the smallest array.
 *
 * @param config
 * @param sceneSetup Callback for setting up the scene
 * @param durations List of durations each leg should take
 * @param positions List of waypoint positions
 * @param focuses List of waypoint focus positions
 * @param additionalTracks Additional animation tracks
 * @param endWait The length of time to wait after completing the full path
 */
export function sceneFlyover(config, durations, positions, focuses, sceneSetup, additionalTracks = () => {
    return [];
}, endWait = 5) {
    return __awaiter(this, void 0, void 0, function* () {
        yield Runner.run(config, (renderer, camera) => __awaiter(this, void 0, void 0, function* () {
            yield sceneSetup(renderer, camera);
            const [pTrack, rTrack] = buildFlyoverTracks(camera, positions, focuses, durations, endWait);
            const out = [pTrack, rTrack];
            out.push(...additionalTracks());
            return out;
        }));
    });
}
